module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 23
// module chunks = 0